const common = require("lib/labels/_common");

// Home.platform.theme

module.exports = {
  themeList: {
    title: {
      en: "Themes",
      fr: "Thèmes"
    },
    title_delete_check: common.title_delete_check,
    content_delete_check: common.content_delete_check,
    no: common.no,
    yes: common.yes,
    edit: common.edit,
    remove: common.remove,
    select: {
      en: "Select",
      fr: "Sélectionner"
    },
    detailed: {
      name: {
        en: "Name",
        fr: "Nom"
      }
    }
  },
  themeForm: {
    stepTitle: {
      en: "Icons",
      fr: "Logos"
    },
    title: {
      edition: {
        en: "Platform icons",
        fr: "Logos de la plateforme"
      }
    },
    name: common.name,
    darklight: {
      en: "Dark",
      fr: "Sombre"
    },
    logoBackground: {
      en: "Logo background",
      fr: "Fond du logo"
    },
    typo: {
      en: "Typography",
      fr: "Typographie"
    },
    frontPageAndInterface: {
      en: "Front page and interfaces",
      fr: "Page d'acceuil et interfaces"
    },
    addBackToLogo: {
      en: "Add background to logo",
      fr: "Ajouter un fond au logo"
    },
    generateColors: {
      en: "Generate harmonious color",
      fr: "Générer des couleurs harmonieuses"
    },
    addedColors: {
      en: "Added presets colors",
      fr: "Couleurs pré-configurées"
    },
    sizeBarTitle: {
      en: "Size of the project's navbar",
      fr: "Taille de la barre de navigation de projet"
    },
    onglet: {
      en: "Tab",
      fr: "Gestion de l'onglet"
    },
    themeCreation: {
      en: "Theme creation",
      fr: "Creation d'un thème"
    },
    themeEdition: {
      en: "Modfiying the theme ",
      fr: "Modification du thème "
    },
    tabTitle: {
      en: "Tab's title",
      fr: "Titre de l'onglet"
    },
    existingTheme: {
      en: "Use an existing theme as base",
      fr: "Utiliser un theme existant comme base"
    }
  }
};
